import "./featureSection.scss";

export default function FeatureSection({ data, index }) {
  if (!data) return null;

  const isReverse = index % 2 === 1;

  return (
    <section
      className={`feature ${isReverse ? "feature--reverse" : ""}`}
      id={data.id}
    >
      <div className="feature__text">
        <h2>{data.title}</h2>
        <div className="line" />
        <p>{data.description}</p>
      </div>

      <img className="feature__image" src={data.image} alt={data.title} />
    </section>
  );
}
